import { useState, useEffect, useContext } from 'react'
import { BiX } from "react-icons/bi";
import { EditPatrimonio, getComponentMap } from '../../../General/Format/patrimonio'
import { AnexosContext } from '../../../../contexts/anexosProvider';
import { PatrimonioContext } from '../../../../contexts/patrimonioProvider';
import { UserContext } from '../../../../contexts/userProvider';
import imprimirEtiqueta from '../../imprimirEtiqueta';

const EditPatrimonioModal = ({ setEditModal, patrimonioSelecionado, patrimonioType, patrimonios }) => {
  const { anexosByClient } = useContext(AnexosContext);
  const { marcasByFornecedor, modelosByMarca, updatePatrimonioById, updatePatrimonioNfsById } = useContext(PatrimonioContext);
  const { setAlert } = useContext(UserContext);
  const [patrimonio, setPatrimonio] = useState({})
  const [anexos, setAnexos] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    let patrimonio = patrimonios.find(p => p.id === patrimonioSelecionado);
    setPatrimonio(patrimonio);
  }, [patrimonios]);

  useEffect(() => {
    let idCliente = patrimonio?.id_cliente;
    if (idCliente) {
      anexosByClient(idCliente).then((anexos) => {
        setAnexos(anexos);
      });
    }
  }, [patrimonio?.id_cliente]);

  useEffect(() => {
    let idFornecedor = patrimonio?.id_fornecedor ? patrimonio?.id_fornecedor : 2;
    if (idFornecedor) {
      marcasByFornecedor(idFornecedor).then((marcas) => {
        setMarcas(marcas);
      });
    }
  }, [patrimonio?.id_fornecedor]);

  useEffect(() => {
    let idMarca = patrimonio?.id_marca;
    if (idMarca) {
      modelosByMarca(idMarca).then((modelos) => {
        setModelos(modelos);
      });
    }
  }, [patrimonio?.id_marca]);

  const handleEditCloseModal = () => {
    setEditModal(false)
  }

  // Imprime com o que está na tela (mesmo mapeamento do cadastro:
  // local = nome do anexo, setor = nome, ramal = ramal).
  const handleImprimirEtiqueta = () => {
    imprimirEtiqueta({
      local: anexos.find((a) => String(a.id) === String(patrimonio?.id_anexo))?.nome || patrimonio?.nome_anexo || '',
      setor: patrimonio?.nome || '',
      ramal: patrimonio?.ramal || '',
    });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatrimonio({ ...patrimonio, [name]: value });
  }


  const handleSaveClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const patrimonioAtualizado = { ...patrimonio };

      delete patrimonioAtualizado.equipamento;
      delete patrimonioAtualizado.nome_anexo;
      delete patrimonioAtualizado.nome_cliente;
      patrimonioAtualizado.updated_at = new Date().toISOString().slice(0, 19).replace("T", " ");

      const requiredFields = ['id_cliente', 'id_anexo', 'id_marca', 'id_modelo'];
      //, 'nome', 'setor', 'ramal'
      if (requiredFields.some(field => !patrimonioAtualizado[field])) {
        setAlert({ visible: true, title: "Atenção!", placeholder: 'Todos os campos são obrigatórios.', confirm: false, type: "warning" });
        setLoading(false);
        return;
      }
      if (patrimonioType === 'inventario') delete patrimonioAtualizado.password_telefone;

      const updateFunction = patrimonioType === 'novo' ? updatePatrimonioNfsById : updatePatrimonioById;
      await updateFunction(patrimonioAtualizado);
      setPatrimonio({});
      setEditModal(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const dados = EditPatrimonio(patrimonio, anexos, marcas, modelos);
  const componentMap = getComponentMap(handleInputChange, 'modal');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4' onClick={(e) => e.target === e.currentTarget && handleEditCloseModal()}>
      <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-6xl w-full mx-4 max-h-[95vh] overflow-hidden flex flex-col'>
        {/* Header */}
        <div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6 relative'>
          <button 
            onClick={handleEditCloseModal} 
            className='absolute top-4 right-4 p-2 text-white hover:text-red-200 transition-colors duration-200 rounded-full hover:bg-white/20'
          >
            <BiX className='w-8 h-8' />
          </button>
          
          <div className='pr-16'>
            <h1 className='text-3xl font-bold text-white mb-2'>
              Editar Patrimônio
            </h1>
            <p className='text-white/80'>
              ID: {patrimonio?.id} • {patrimonio?.produto || patrimonio?.equipamento || 'Patrimônio'}
            </p>
          </div>
        </div>

        {/* Content */}
        <div className='flex-1 overflow-y-auto p-6'>
          {!patrimonio || Object.keys(patrimonio).length === 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {[...Array(12)].map((_, index) => (
                <div key={index} className="animate-pulse">
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded mb-2"></div>
                  <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded"></div>
                </div>
              ))}
            </div>
          ) : (
            <form onSubmit={handleSaveClick} onKeyDown={handleKeyDown} className="h-full">
              <div className="space-y-8">
                {/* Seção: Informações Básicas */}
                <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="editar:basico">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-vox-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                    </svg>
                    Informações Básicas
                  </h3>
                  <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
                    {dados.filter(dado => 
                      ['Equipamento', 'Cliente', 'Anexo', 'Fornecedor', 'Marca', 'Modelo'].includes(dado.titulo)
                    ).map((dado) => (
                      <div key={dado.titulo} className={`${
                        dado.titulo === 'Equipamento' ? 'md:col-span-2 xl:col-span-3' : ''
                      }`}>
                        {componentMap.Cadastro(dado)}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Seção: Detalhes do Usuário */}
                <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="editar:usuario">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-vox-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                    Detalhes do Usuário
                  </h3>
                  <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
                    {dados.filter(dado => 
                      ['Nome', 'Setor', 'Ramal', 'IP', 'PassWord'].includes(dado.titulo)
                    ).map((dado) => (
                      <div key={dado.titulo}>
                        {componentMap.Cadastro(dado)}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Seção: Identificação Técnica */}
                <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="editar:tecnica">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
                    </svg>
                    Identificação Técnica
                  </h3>
                  <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
                    {dados.filter(dado => 
                      ['Número de Série', 'MAC', 'Nº etiqueta patrimonio'].includes(dado.titulo)
                    ).map((dado) => (
                      <div key={dado.titulo}>
                        {componentMap.Cadastro(dado)}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Seção: Controle de Envio */}
                <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6" data-tour-id="editar:envio">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    Controle de Envio
                  </h3>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                    {dados.filter(dado => 
                      ['Data de envio', 'Hora de envio'].includes(dado.titulo)
                    ).map((dado) => (
                      <div key={dado.titulo}>
                        {componentMap.Cadastro(dado)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-4">
          <button
            onClick={handleImprimirEtiqueta}
            data-tour-id="editar:imprimir"
            className='px-6 py-2 bg-vox-green-600 hover:bg-vox-green-700 text-white font-medium rounded-lg transition-colors duration-200'
          >
            Imprimir etiqueta
          </button>
          <button
            onClick={handleEditCloseModal}
            className='px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200'
          >
            Cancelar
          </button>
          <button 
            onClick={handleSaveClick}
            disabled={loading}
            data-tour-id="editar:salvar"
            className='px-6 py-2 bg-gradient-to-r from-vox-blue-500 to-vox-blue-600 hover:from-vox-blue-600 hover:to-vox-blue-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center space-x-2'
          >
            {loading ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Salvando...</span>
              </>
            ) : (
              <span>Salvar</span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default EditPatrimonioModal
